{
  "name": "passlink-cloud",
  "buildNumber": "2.2.0.27",
  "version": "2.2.0.27",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:development": "ng build --configuration=development",
    "build:qa": "ng build --configuration=qa && node scripts/obfuscate.js",
    "build:staging": "ng build --configuration=staging && node scripts/obfuscate.js",
    "build:prod": "ng build --configuration=production && node scripts/obfuscate.js",
    "build:production": "ng build --configuration=production && node scripts/obfuscate.js",
    "build:analyze": "ng build --configuration=production --stats-json",
    "analyze": "npm run build:analyze && webpack-bundle-analyzer dist/passlink-cloud/stats.json --mode static --report dist/passlink-cloud/bundle-report.html --no-open",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "eslint \"src/app/**/*.ts\" --ignore-pattern \"**/*.spec.ts\" --ignore-pattern \"src/app/core/logging/logger.service.ts\"",
    "check:locators": "node scripts/check-locators.js",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:report": "playwright show-report"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.34",
    "@angular/cdk": "~20.2.14",
    "@angular/common": "20.3.34",
    "@angular/compiler": "20.3.34",
    "@angular/core": "20.3.34",
    "@angular/forms": "20.3.34",
    "@angular/platform-browser": "20.3.34",
    "@angular/platform-browser-dynamic": "20.3.34",
    "@angular/router": "20.3.34",
    "@faker-js/faker": "^10.6.0",
    "@firebase/app": "0.16.2",
    "@jsverse/transloco": "^8.4.0",
    "@primeng/themes": "^20.0.0",
    "chart.js": "^4.5.0",
    "crypto-js": "^4.2.0",
    "dompurify": "^3.4.17",
    "file-saver": "^2.0.5",
    "firebase": "^12.19.0",
    "jszip": "^3.10.1",
    "jwt-decode": "^4.0.0",
    "marked": "^14.1.4",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-cookie-service": "^20.0.0",
    "pdfjs-dist": "^6.2.108",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^20.0.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "web-vitals": "^4.2.4",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.26",
    "@angular/cli": "^20.3.26",
    "@angular/compiler-cli": "20.3.34",
    "@playwright/test": "^1.60.0",
    "@tailwindcss/postcss": "^4.3.3",
    "@types/crypto-js": "^4.2.2",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "@types/lodash-es": "^4.17.12",
    "angular-eslint": "21.0.1",
    "autoprefixer": "^10.4.21",
    "dotenv": "^16.4.5",
    "eslint": "^9.39.1",
    "jasmine-core": "~5.6.0",
    "javascript-obfuscator": "^5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.28",
    "sass": "^1.58.3",
    "tailwindcss": "^3.4.3",
    "typescript": "~5.8.2",
    "typescript-eslint": "8.46.4",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "overrides": {
    "@grpc/grpc-js": "1.14.6",
    "zod": "4.6.7"
  }
}
